import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import voca from "voca";
import VueI18n from 'vue-i18n'
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import '@/assets/css/main.css';
import "@/util/xdate";
// 字符串处理类库
window.v = voca;
Vue.use(ElementUI)
Vue.use(VueI18n)
Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) });
Vue.config.productionTip = false


const i18n = new VueI18n({
    locale: 'en-us', // 语言标识
    messages: {
        'zh-cn': {...require('./assets/lang/zh'), ...zhLocale }, // 中文语言包
        'en-us': {...require('./assets/lang/en'), ...enLocale } // 英文语言包
    }
})

window.$i18n = i18n;


new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')